/**
 * @param {querySelector} burger - burger selector 
 * @param {querySelector} menu - menu selector
 */
export default function initMobilemenu(burgerClass, menuClass) {
    const burger = document.querySelector(".header__menu")
    if (!burger) return

    const menu = document.querySelector(".header__mobilemenu")

    burger.addEventListener("click", () => {
        if (body.classList.contains("mobilemenu-opened")) {
            document.removeEventListener("click", outsideEvtListener)
        } else {
            setTimeout(() => {
                document.addEventListener("click", outsideEvtListener)
            })
        }
        menu.classList.toggle("opened")
        body.classList.toggle("mobilemenu-opened")
        burger.classList.toggle('opened')
    })

    function outsideEvtListener(evt) {
        if (evt.target === menu || menu.contains(evt.target)) return
        burger.classList.toggle("opened")
        body.classList.toggle("mobilemenu-opened")
        burger.classList.toggle('opened')
        document.removeEventListener("click", outsideEvtListener)
    }
}
